// extracted by mini-css-extract-plugin
export default {"ThemeButton":"ThemeButtonDark_ThemeButton__npmw8"};